import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {Goal} from "../../models/goal";
import {Timestamp} from "firebase/firestore";

@Component({
  selector: 'tandem-goal-form',
  templateUrl: './goal-form.component.html',
  styleUrls: ['./goal-form.component.scss']
})
export class GoalFormComponent implements OnInit {

  goalType: 'Short-Term' | 'Mid-Term' | 'Long-Term' | null = null;
  goalForm: FormGroup = new FormGroup<any>({});
  userId: string = '';

  inputGoal?: Goal;

  public modalRef?: ModalRef
  constructor(private fb: FormBuilder,) {
  }

  ngOnInit(): void {

    const today = new Date();
    let targetDate: Date | null = new Date();

    switch (this.goalType) {
      case 'Short-Term':
        targetDate.setMonth(today.getMonth() + 1);
        break;
      case 'Mid-Term':
        targetDate.setMonth(today.getMonth() + 3);
        break;
      case 'Long-Term':
        targetDate.setFullYear(today.getFullYear() + 1);
        break;
      default:
        targetDate = null;
    }

    if (this.inputGoal) {
      this.goalForm = this.fb.group({
        name: [this.inputGoal.name, Validators.required],
        startDate: [this.inputGoal.startDate.toDate().toISOString().substring(0, 10), Validators.required],
        targetDate: [this.inputGoal.targetDate.toDate().toISOString().substring(0, 10), Validators.required],
      });
    } else {
      this.goalForm = this.fb.group({
        name: [null, Validators.required],
        startDate: [today.toISOString().substring(0, 10), Validators.required],
        targetDate: [targetDate ? targetDate.toISOString().substring(0, 10) : null, Validators.required],
      });
    }
  }

  public close() {
    this.modalRef?.close(false);
  }

  public submit() {
    const goal: Goal = {
      name: this.goalForm.get('name')?.value,
      type: this.goalType,
      startDate: Timestamp.fromDate(new Date(this.goalForm.get('startDate')?.value)),
      targetDate: Timestamp.fromDate(new Date(this.goalForm.get('targetDate')?.value)),
      dateModified: Timestamp.now(),
      userId: this.userId,
      dateCreated: this.inputGoal ? this.inputGoal.dateCreated : Timestamp.now(),
      completed: this.inputGoal ? this.inputGoal.completed : false
    } as Goal;

    if (this.inputGoal) {
      goal.id = this.inputGoal.id;
    }
    this.modalRef?.close(goal);
  }

  private formatDate(date: Date) {
    let day: string | number = date.getDate();
    let month: string | number = date.getMonth() + 1; // January is 0!
    let year = date.getFullYear();

    // ensure double digits
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return month + '/' + day + '/' + year;
  }
}
